/**
 * MNM Product Card - AJAX Add to Cart
 * Intercepts form submit, adds to cart via fetch, updates cart UI and shows "Added" feedback.
 */
(function () {
  const addedText = window.cartStrings?.addedToCart || 'Added';
  const addToCartText = window.variantStrings?.addToCart || 'Add to cart';

  function getCartComponent() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  document.addEventListener('submit', function (evt) {
    const form = evt.target?.closest?.('.card-mnm__atc-form');
    if (!form || evt.target !== form) return;

    evt.preventDefault();

    const submitBtn = form.querySelector('.card-mnm__atc-btn[type="submit"], button[type="submit"]');
    if (!submitBtn || submitBtn.getAttribute('aria-disabled') === 'true') return;

    const originalText = submitBtn.textContent?.trim() || addToCartText;

    submitBtn.setAttribute('aria-disabled', 'true');
    submitBtn.classList.add('card-mnm__atc-btn--loading');

    const config = {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        Accept: 'application/json',
      },
    };

    const formData = new FormData(form);
    const cart = getCartComponent();
    if (cart && typeof cart.getSectionsToRender === 'function') {
      const sections = cart.getSectionsToRender();
      sections.forEach(function (section) {
        var id = section.id || (section.section !== undefined ? section.section : null);
        if (id) formData.append('sections', id);
      });
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }
    }
    config.body = formData;

    fetch(window.routes?.cart_add_url || '/cart/add', config)
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.status && data.message) {
          submitBtn.classList.remove('card-mnm__atc-btn--loading');
          submitBtn.removeAttribute('aria-disabled');
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartError, {
              source: 'card-mnm',
              message: data.message,
            });
          }
          return;
        }

        submitBtn.textContent = addedText;
        submitBtn.classList.add('card-mnm__atc-btn--added');

        if (cart && typeof cart.renderContents === 'function' && data.sections) {
          cart.renderContents(data);
        } else if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'card-mnm', cartData: data });
        }

        setTimeout(function () {
          submitBtn.textContent = originalText;
          submitBtn.classList.remove('card-mnm__atc-btn--added', 'card-mnm__atc-btn--loading');
          submitBtn.removeAttribute('aria-disabled');
        }, 2000);
      })
      .catch(function (err) {
        console.error('Card ATC error:', err);
        submitBtn.classList.remove('card-mnm__atc-btn--loading');
        submitBtn.removeAttribute('aria-disabled');
      });
  });
})();
